import StopNumberOfItemsCell from './component';
import { compose } from 'recompose';
import { connect } from 'react-redux';

import { withJourneyCardSelectors } from 'modules/journey/card/hoc';

const palletTypeText = {
  EU_PALLET: 'Eu',
  CUSTOM_PALLET: 'Sp',
  US_PALLET: 'Us',
  MIXED_PALLET: 'Mx',
};

const fields = ['real_pallets', 'type_pallets', 'load_types'];

const enhance = compose(
  withJourneyCardSelectors,
  connect((state, props) => {
    const {
      real_pallets: realPallets,
      type_pallets: typePallets,
      load_types: loadType,
    } = props.selectors.getJourneyStopFields(state, props.journeyId, props.stopId, fields);
    return {
      numberOfItems: realPallets,
      typeOfPallets: palletTypeText[typePallets],
      loadType: loadType[0],
    };
  })
);

export default enhance(StopNumberOfItemsCell);
